import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const AppointmentsActions = importer('Stores/Appointments/Actions')
const { getUpcomingAppointments } = importer('APIs/appointments', null)
const { tokens } = importer('Stores/Users/Select', null)
export default function * main ({ donorSfid }) {
  try {
    yield put(AppointmentsActions.getUpcomingAppointmentsLoading())
    /* GETTING TOKENS */
    let res = null
    const _tokens = yield select(tokens)
    if (_tokens) {
      const { token_type, id_token } = _tokens
      const token = `${token_type} ${id_token}`
      res = yield getUpcomingAppointments(donorSfid, token)
    } else {
      res = yield getUpcomingAppointments(donorSfid)
    }
    if (res && (res.status === 200 || res.status === 304) && res.data) {
      yield put(AppointmentsActions.getUpcomingAppointmentsSuccess(res.data))
    } else throw Error(res)
  } catch (error) {
    yield put(AppointmentsActions.getUpcomingAppointmentsFailure(error))
  }
}
